import request from '@/utils/request'

function unwrap<T>(promise: Promise<any>): Promise<T> {
  return promise.then((res: any) => {
    if (String(res.data.code) === '1') {
      return res.data.data as T
    }
    return Promise.reject(new Error((res.data && res.data.msg) || '请求失败'))
  })
}

/** 操作类型中文映射 */
export const ACTION_MAP: Record<string, string> = {
  create_bill: '新增账单',
  auto_create_bill: '自动记账',
  update_bill: '修改账单',
  delete_bill: '删除账单',
  save_pending: '保存待确认',
  confirm_pending: '确认账单',
  reject_pending: '拒绝待确认',
  register: '注册账号',
  login: '登录账号',
  upload_release: '发布版本'
}

export interface BillOperationLogItem {
  id: number
  userId: string
  userName: string
  action: string
  targetType: string
  targetId: string
  summary: string
  detail: string
  createTime: string
}

export interface BillOperationLogPageResult {
  total: number
  records: BillOperationLogItem[]
}

/** 分页查询青山记账操作日志 */
export const pageBillOperationLogs = (params: {
  page?: number
  pageSize?: number
  keyword?: string
  action?: string
  startDate?: string
  endDate?: string
}) =>
  unwrap<BillOperationLogPageResult>(
    request({ url: '/mp/bill-operation-log/page', method: 'get', params })
  )
